import moment                      from 'moment';
import React                       from 'react';
import { Duration                } from "moment";
import { useEffect, useState, FC } from "react";

interface IProps {
    tock: number
    setSubmitDisabled: Function;
};

export const Timer: FC<IProps> = (props) => {
    const {tock, setSubmitDisabled} = props
    
    const [timeLeft, setTimeLeftState] = useState<Duration>(moment.duration(tock-moment.now()));

    useEffect(() => {
        const intervalId = setInterval(() => {
          setTimeLeftState(moment.duration(tock - moment.now()));
        }, 1000);
    
        return () => {
          clearInterval(intervalId);
        };
      }, [tock]);
    
      useEffect(() => {
        if (timeLeft.asSeconds() <= 0) {
          setSubmitDisabled(false);
        }
      }, [timeLeft, setSubmitDisabled]);
    
    return (
        <div>
            {timeLeft.asHours() >= 1 && 
                <span>
                    {String(Math.trunc(timeLeft.asHours())).padStart(2, '0')}:
                    {String(timeLeft.minutes()).padStart(2, '0')}:
                    {String(timeLeft.seconds()).padStart(2, '0')}
                </span>
            }            
            {timeLeft.asHours() < 1 &&
                <span>
                    {String(timeLeft.minutes()).padStart(2, '0')}:
                    {String(timeLeft.seconds()).padStart(2, '0')}
                </span>
            }
        </div>
    );
}
